module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 113.19af2089.png";